import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import _ from 'lodash';
import {
  ControlLabel,
  FormGroup,
  FormControl,
  HelpBlock
} from 'react-bootstrap';
import NumberAutoFormat from '../NumberAutoFormat';

class Field extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);

    if (this.props.type === 'phoneNumber') {
      this.phoneFormat = this.props.phoneFormat || '###-###-####';
    }
  }

  onChange(e) {
    if (this.props.onChange) {
      const name = _.get(e, 'target.name', '');
      const value = _.get(e, 'target.value', '');

      if (value.trim() === '') {
        this.props.onChange(name, '');
      } else if (this.props.type === 'number') {
        this.changeFieldNumber(name, value);
      } else {
        this.props.onChange(name, value);
      }
    }
  }

  onValueChange(values, e) {
    if (this.props.onChange) {
      const name = _.get(e, 'target.name', '');
      const value = _.get(values, 'value', '');

      this.props.onChange(name, value.trim());
    }
  }

  onFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e.target.name, e.target.value);
    }
  }

  onKeyPress(event) {
    if (this.props.onKeyPress && typeof this.props.onKeyPress === 'function') {
      this.props.onKeyPress(event);
    }
  }

  changeFieldNumber(key, value) {
    if (!value || value === '' || /^(\d+)$/.test(value)) {
      this.props.onChange(key, value);
    }
  }

  render() {
    const props = this.props;
    const id = _.get(props, 'id',uuid());
    let value = props.value || '';

    let formControl = (
      <FormControl
        inputRef={props.inputRef}
        onChange={this.onChange}
        name={props.name}
        id={id}
        value={value}
        type={props.type}
        disabled={props.disabled}
        pattern={props.pattern}
        onFocus={this.onFocus}
        maxLength={props.maxLength}
        placeholder={props.placeholder}
        onKeyPress={this.onKeyPress}
        autoFocus={props.autoFocus}
      />
    );
    if (props.type === 'static') {
      formControl = (
        <FormControl.Static>
          {value}
        </FormControl.Static>
      );
    } else if (props.type === 'number') {
      formControl = (
        <NumberAutoFormat
          allowNegative={props.allowNegative}
          className="form-control"
          prefix={''}
          decimalScale={props.decimalScale}
          format={props.format}
          getInputRef={props.inputRef}
          onValueChange={this.onValueChange}
          name={props.name}
          id={id}
          value={value}
          disabled={props.disabled}
          pattern={props.pattern}
          onFocus={this.onFocus}
          placeholder={props.placeholder}
          onKeyPress={this.onKeyPress}
          autoFocus={props.autoFocus}
          thousandSeparator={props.thousandSeparator}
          decimalSeparator={props.decimalSeparator}
          maxValue={props.maxValue}
        />
      );
    } else if (props.type === 'phoneNumber') {
      formControl = (
        <NumberAutoFormat
          format={this.phoneFormat}
          getInputRef={props.inputRef}
          onChange={this.onChange}
          name={props.name}
          id={id}
          value={value}
          disabled={props.disabled}
          pattern={props.pattern}
          onFocus={this.onFocus}
          placeholder={props.placeholder}
          onKeyPress={this.onKeyPress}
          className="form-control"
          autoFocus={props.autoFocus}
        />
      );
    } else if (props.type === 'textarea') {
      formControl = (
        <FormControl
          inputRef={props.inputRef}
          onChange={this.onChange}
          name={props.name}
          id={id}
          value={value}
          type={props.type === 'number' ? '' : props.type}
          disabled={props.disabled}
          pattern={props.pattern}
          componentClass="textarea"
          rows={props.rows}
          placeholder={props.placeholder}
          onKeyPress={this.onKeyPress}
          autoFocus={props.autoFocus}
        />
      );
    }

    let labelContent = (<ControlLabel>{props.label}</ControlLabel>);
    if (React.isValidElement(props.label)) {
      labelContent = props.label;
    }

    const inputContainer = (
      <div className={`input-container ${props.inputIcon ? 'input-icon' : ''} ${props.inputUnit ? 'input-unit' : ''}`}>
        {props.inputIcon ? (<i className={`${props.inputIcon} icon`}></i>) : ''}
        {formControl}
        {props.inputUnit ? (<span className='unit'>{props.inputUnit}</span>) : ''}
      </div>
    );

    if (props.hideLable) {
      return (
        <FormGroup
          controlId={id}
          validationState={props.validationState}
          className={props.className}>
          {inputContainer}
          {props.help && <FormControl.Feedback />}
          {props.help && <HelpBlock>{props.help}</HelpBlock>}
        </FormGroup>
      );
    }
    return (
      <FormGroup
        controlId={id}
        validationState={props.validationState}
        className={props.className}>
        {labelContent}
        {inputContainer}
        {props.help && <FormControl.Feedback />}
        {props.help && <HelpBlock>{props.help}</HelpBlock>}
      </FormGroup>
    );
  }
}

Field.propTypes = {
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  id: PropTypes.string,
  value: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  phoneFormat: PropTypes.string,
  inputRef: PropTypes.func,
  help: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  rows: PropTypes.string,
  placeholder: PropTypes.string,
  hideLable: PropTypes.bool,
  onKeyPress: PropTypes.string,
  maxLength: PropTypes.number,
  maxValue: PropTypes.number,
  autoFocus: PropTypes.bool,
  allowNegative: PropTypes.bool,
};

Field.defaultProps = {
  allowNegative: false,
  hideLable: false,
  autoFocus: false,
  decimalScale: 2,
};

export default Field;



// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/Wrapper/Field.js